<template>
    <div class="user-box">
        <div class="row align-items-center">
            <div class="user-box__avatar-box">
                <div class="user-box__avatar-box__avatar-container">
                    <img
                        class="user-box__avatar-box__avatar-container__avatar-image"
                        :alt="review.member.name"
                        :src="review.member.avatar"
                        loading="lazy"
                    />
                </div>
                <img class="user-box__avatar-box__avatar-icon" src="/nuxt-assets/icons/review.svg" loading="lazy" />
            </div>

            <section class="row user-info">
                <div class="col-12 col-sm-auto">
                    <div class="user-box__name font-weight-bold">
                        {{ review.member.name }}
                    </div>

                    <div class="mt-2">
                        <span v-if="review.member.isPilulkaEmployee" class="text-nowrap">
                            {{ $t('reviewClub.employee') }}
                        </span>

                        <span v-else class="text-nowrap d-inline-flex text-success fs-12">
                            <img
                                v-lazy-load
                                class="me-1"
                                src="/nuxt-assets/images/lazy-load-error.svg"
                                data-src="/nuxt-assets/images/icons/check-circle.svg"
                                :alt="`review.product.id`"
                            />
                            {{ $t('reviewClub.verified') }}
                        </span>
                    </div>

                    <div v-if="review.purchaseDate !== null" class="fs-6 mt-1 text-dark">
                        {{ review.purchaseDate }}
                    </div>
                </div>

                <div class="col-12 col-sm-auto pt-1 pt-sm-0 ml-auto">
                    <div v-if="review.recommend" class="d-flex align-items-center text-success fwb fs-14">
                        <img
                            v-lazy-load
                            src="/nuxt-assets/images/lazy-load-error.svg"
                            data-src="/nuxt-assets/images/icons/like-circle.svg"
                            class="pe-2"
                            :alt="$t('reviewClub.customerRecommended')"
                        />
                        {{ $t('reviewClub.customerRecommended') }}
                    </div>
                    <div v-else class="d-flex align-items-center text-danger fwb fs-14">
                        <img
                            v-lazy-load
                            src="/nuxt-assets/images/lazy-load-error.svg"
                            data-src="/nuxt-assets/images/icons/dislike-circle.svg"
                            class="pe-2"
                            :alt="$t('reviewClub.customerNotRecommended')"
                        />
                        {{ $t('reviewClub.customerNotRecommended') }}
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Review from '~/models/ReviewClub/Review'

export default {
    props: {
        review: {
            type: Object as PropType<Review>,
            default: () => ({} as Review),
        },
    },
}
</script>

<style lang="scss" scoped>
.user-info {
    width: calc(100% - 92px);
    padding-left: 1rem;
}

.user-box {
    width: 100%;
    border-radius: 5px 0 0 5px;

    &__avatar-box {
        width: 92px;
        border-radius: 10px 0 0 10px;
        position: relative;

        &__avatar-container {
            margin: 10px 12px;
            width: 66px;
            height: 66px;
            position: relative;
            overflow: hidden;
            border-radius: 50%;
            border: 3px solid transparent;
            display: flex;
            align-items: center;
            justify-content: center;

            &--pilulka {
                border: 3px solid $color-cta;
            }
        }

        &__avatar-icon {
            position: absolute;
            top: 50px;
            right: 7px;
        }
    }

    &__verify {
        font-size: 13px;
    }
}
</style>
